export const SORT_TOOLTIP_OPENER = 'sort-order-link';
export const SORT_MODAL_OPEN_BUTTON = 'sorting-modal-opener';
export const CATEGORY_BUTTON = 'category-name';
export const PAGE_NUMBER = 'page-number';
export const CERTIFICATE_TOGGLE = 'has-valid-certificate-switch';
export const MOBILE_APP_DOWNLOAD_BANNER = 'mobile-app-download-banner';
export const MOBILE_APP_DOWNLOAD_BANNER_DISMISS =
  'mobile-app-download-banner-dismiss';
